import React from 'react'
import Index from '../views/dashboard/index'
// import { Switch, Route } from 'react-router-dom'
// user
import UserProfile from '../views/dashboard/app/user-profile';
import UserAdd from '../views/dashboard/app/user-add';
import UserList from '../views/dashboard/app/user-list';
import UserListTemplate from '../views/dashboard/app/user-list-template';
import AccountSetting from '../views/dashboard/app/account-setting';
// import userProfileEdit from '../views/dashboard/app/user-privacy-setting';
// widget
import Widgetbasic from '../views/dashboard/widget/widgetbasic';
import Widgetcard from '../views/dashboard/widget/widgetcard';
import Widgetchart from '../views/dashboard/widget/widgetchart';
// icon
import Solid from '../views/dashboard/icons/solid';
import Outline from '../views/dashboard/icons/outline';
import DualTone from '../views/dashboard/icons/dual-tone';
// Form
import FormElement from '../views/dashboard/from/form-element';
import FormValidation from '../views/dashboard/from/form-validation';
import FormWizard from '../views/dashboard/from/form-wizard';
// table
import BootstrapTable from '../views/dashboard/table/bootstrap-table';
import TableData from '../views/dashboard/table/table-data';

// map
import Vector from '../views/dashboard/maps/vector';
import Google from '../views/dashboard/maps/google';

//extra
import PrivacyPolicy from '../views/dashboard/extra/privacy-policy';
import TermsofService from '../views/dashboard/extra/terms-of-service';

//TransitionGroup
// import { TransitionGroup, CSSTransition } from "react-transition-group";
//Special Pages
import Billing from '../views/dashboard/special-pages/billing';
import Kanban from '../views/dashboard/special-pages/kanban';
import Pricing from '../views/dashboard/special-pages/pricing';
import Timeline from '../views/dashboard/special-pages/timeline';
import Calender from '../views/dashboard/special-pages/calender';
import RtlSupport from '../views/dashboard/special-pages/RtlSupport'
import Subjects from '../views/dashboard/management/subjects'
import Statistics from '../views/dashboard/statistics';
import QuizBuilder from '../views/dashboard/quiz-builder';
import Scanner from '../views/dashboard/scanner';
import ScannerLive from '../views/dashboard/scanner-live';
import ToolsPage from '../views/dashboard/tools/ToolsPage';
import PdfRepairTool from '../views/dashboard/tools/PdfRepairTool';
import SubjectCompareTool from '../views/dashboard/tools/SubjectCompareTool';

//auth
import ProtectedRoute from "../components/auth/ProtectRoute";

//admin
import Admin from '../views/dashboard/admin/admin';
import SiteSettings from '../views/dashboard/admin/site-settings';
import Default from '../layouts/dashboard/default';
import QuizPage from '../views/dashboard/management/quiz';




export const DefaultRouter = [
    {
        path: '/',
        element: <Default />,
        children: [
            
            {
                path: 'dashboard',
                element: <ProtectedRoute><Index /></ProtectedRoute>
            },
            {
                path: 'calendar',
                element: <ProtectedRoute><Calender /></ProtectedRoute>
            },
            {
                path: 'statistics',
                element: <ProtectedRoute><Statistics /></ProtectedRoute>
            },
            {
                path: 'quiz',
                element: <ProtectedRoute><QuizBuilder /></ProtectedRoute>
            },
            {
                path: 'scanner',
                element: <ProtectedRoute><Scanner /></ProtectedRoute>
            },
            {
                path: 'scanner-live',
                element: <ProtectedRoute><ScannerLive /></ProtectedRoute>
            },
            {
                path: 'tools',
                element: <ProtectedRoute><ToolsPage /></ProtectedRoute>
            },
            {
                path: 'tools/pdf-repair',
                element: <ProtectedRoute><PdfRepairTool /></ProtectedRoute>
            },
            {
                path: 'tools/subject-compare',
                element: <ProtectedRoute><SubjectCompareTool /></ProtectedRoute>
            },
            {
                path: 'dashboard/calendar',
                element: <ProtectedRoute><Calender /></ProtectedRoute>
            },
            {
                path: 'archives',
                element: <ProtectedRoute><Subjects /></ProtectedRoute>
            },
            {
                path: 'archives/subjects',
                element: <ProtectedRoute><Subjects /></ProtectedRoute>
            },
            {
                path: 'start-quiz',
                element: <ProtectedRoute allowedRoles={['super-admin']}><QuizPage /></ProtectedRoute>
            },
            {
                path: 'dashboard/management/subjects',
                element: <ProtectedRoute><Subjects /></ProtectedRoute>
            },
            {
                path: 'dashboard/management/start-quiz',
                element: <ProtectedRoute allowedRoles={['super-admin']}><QuizPage /></ProtectedRoute>
            },
            {
                path: 'billing',
                element: <ProtectedRoute allowedRoles={['admin', 'super-admin']}><Billing /></ProtectedRoute>
            },
            {
                path: 'admin-calendar',
                element: <ProtectedRoute allowedRoles={['admin', 'super-admin']}><Calender /></ProtectedRoute>
            },
            {
                path: 'kanban',
                element: <ProtectedRoute allowedRoles={['admin', 'super-admin']}><Kanban /></ProtectedRoute>
            },
            {
                path: 'pricing',
                element: <ProtectedRoute allowedRoles={['admin', 'super-admin']}><Pricing /></ProtectedRoute>
            },
            {
                path: 'timeline',
                element: <ProtectedRoute allowedRoles={['admin', 'super-admin']}><Timeline /></ProtectedRoute>
            },
            {
                path: 'rtl-support',
                element: <ProtectedRoute allowedRoles={['admin', 'super-admin']}><RtlSupport/>,</ProtectedRoute>
            },
            {
                path: 'privacy-policy',
                element: <ProtectedRoute><PrivacyPolicy /></ProtectedRoute>
            },
            {
                path: 'terms-of-service',
                element: <ProtectedRoute><TermsofService /></ProtectedRoute>
            },
            {
                path: 'dashboard/extra/privacy-policy',
                element: <ProtectedRoute><PrivacyPolicy /></ProtectedRoute>
            },
            {
                path: 'dashboard/extra/terms-of-service',
                element: <ProtectedRoute><TermsofService /></ProtectedRoute>
            },
            {
                path: 'dashboard/special-pages/billing',
                element: <ProtectedRoute allowedRoles={['admin', 'super-admin']}><Billing /></ProtectedRoute>
            },
            {
                path: 'dashboard/special-pages/calender',
                element: <ProtectedRoute allowedRoles={['admin', 'super-admin']}><Calender /></ProtectedRoute>
            },
            {
                path: 'dashboard/special-pages/kanban',
                element: <ProtectedRoute allowedRoles={['admin', 'super-admin']}><Kanban /></ProtectedRoute>
            },
            {
                path: 'dashboard/special-pages/pricing',
                element: <ProtectedRoute allowedRoles={['admin', 'super-admin']}><Pricing /></ProtectedRoute>
            },
            {
                path: 'dashboard/special-pages/timeline',
                element: <ProtectedRoute allowedRoles={['admin', 'super-admin']}><Timeline /></ProtectedRoute>
            },
            {
                path: 'dashboard/special-pages/rtl-support',
                element: <ProtectedRoute allowedRoles={['admin', 'super-admin']}><RtlSupport/>,</ProtectedRoute>
            },
            {
                path: 'user-profile',
                element: <ProtectedRoute allowedRoles={['admin', 'super-admin']}><UserProfile /></ProtectedRoute>
            },
            {
                path: 'user-add',
                element: <ProtectedRoute allowedRoles={['admin', 'super-admin']}><UserAdd /></ProtectedRoute>
            },
            {
                path: 'user-list',
                element: <ProtectedRoute allowedRoles={['admin', 'super-admin']}><UserList /></ProtectedRoute>
            },
            {
                path: 'user-list-template',
                element: <ProtectedRoute allowedRoles={['admin', 'super-admin']}><UserListTemplate /></ProtectedRoute>
            },
            {
                path: 'account-setting',
                element: <ProtectedRoute><AccountSetting /></ProtectedRoute>
            },
            {
                path: 'admin',
                element: <ProtectedRoute allowedRoles={['admin', 'super-admin']}><Admin /></ProtectedRoute>
            },
            {
                path: 'site-settings',
                element: <ProtectedRoute allowedRoles={['admin', 'super-admin']}><SiteSettings /></ProtectedRoute>
            },
            {
                path: 'dashboard/app/user-profile',
                element: <ProtectedRoute allowedRoles={['admin', 'super-admin']}><UserProfile /></ProtectedRoute>
            },
            {
                path: 'dashboard/app/user-add',
                element: <ProtectedRoute allowedRoles={['admin', 'super-admin']}><UserAdd /></ProtectedRoute>
            },
            {
                path: 'dashboard/app/user-list-template',
                element: <ProtectedRoute allowedRoles={['admin', 'super-admin']}><UserListTemplate /></ProtectedRoute>
            },
            {
                path: 'dashboard/app/account-setting',
                element: <ProtectedRoute><AccountSetting /></ProtectedRoute>
            },
            {
                path: 'dashboard/admin/admin',
                element: <ProtectedRoute allowedRoles={['admin', 'super-admin']}><Admin /></ProtectedRoute>
            },
            // Widget
            {
                path: 'widgets/basic',
                element: <ProtectedRoute allowedRoles={['admin', 'super-admin']}><Widgetbasic /></ProtectedRoute>
            },
            {
                path: 'widgets/chart',
                element: <ProtectedRoute allowedRoles={['admin', 'super-admin']}><Widgetchart /></ProtectedRoute>
            },
            {
                path: 'widgets/card',
                element: <ProtectedRoute allowedRoles={['admin', 'super-admin']}><Widgetcard /></ProtectedRoute>
            },
            {
                path: 'dashboard/widget/widgetbasic',
                element: <ProtectedRoute allowedRoles={['admin', 'super-admin']}><Widgetbasic /></ProtectedRoute>
            },
            {
                path: 'dashboard/widget/widgetchart',
                element: <ProtectedRoute allowedRoles={['admin', 'super-admin']}><Widgetchart /></ProtectedRoute>
            },
            {
                path: 'dashboard/widget/widgetcard',
                element: <ProtectedRoute allowedRoles={['admin', 'super-admin']}><Widgetcard /></ProtectedRoute>
            },
            // Map
            {
                path: 'maps/google',
                element: <ProtectedRoute allowedRoles={['admin', 'super-admin']}><Google /></ProtectedRoute>
            },
            {
                path: 'maps/vector',
                element: <ProtectedRoute allowedRoles={['admin', 'super-admin']}><Vector /></ProtectedRoute>
            },
            {
                path: 'dashboard/map/google',
                element: <ProtectedRoute allowedRoles={['admin', 'super-admin']}><Google /></ProtectedRoute>
            },
            {
                path: 'dashboard/map/vector',
                element: <ProtectedRoute allowedRoles={['admin', 'super-admin']}><Vector /></ProtectedRoute>
            },
            // Form
            {
                path: 'forms/elements',
                element: <ProtectedRoute allowedRoles={['admin', 'super-admin']}><FormElement /></ProtectedRoute>
            },
            {
                path: 'forms/wizard',
                element: <ProtectedRoute allowedRoles={['admin', 'super-admin']}><FormWizard /></ProtectedRoute>
            },
            {
                path: 'forms/validation',
                element: <ProtectedRoute allowedRoles={['admin', 'super-admin']}><FormValidation /></ProtectedRoute>
            },
            {
                path: 'dashboard/form/form-element',
                element: <ProtectedRoute allowedRoles={['admin', 'super-admin']}><FormElement /></ProtectedRoute>
            },
            {
                path: 'dashboard/form/form-wizard',
                element: <ProtectedRoute allowedRoles={['admin', 'super-admin']}><FormWizard /></ProtectedRoute>
            },
            {
                path: 'dashboard/form/form-validation',
                element: <ProtectedRoute allowedRoles={['admin', 'super-admin']}><FormValidation /></ProtectedRoute>
            },
            // Table
            {
                path: 'tables/bootstrap',
                element: <ProtectedRoute allowedRoles={['admin', 'super-admin']}><BootstrapTable /></ProtectedRoute>
            },
            {
                path: 'tables/data',
                element: <ProtectedRoute allowedRoles={['admin', 'super-admin']}><TableData /></ProtectedRoute>
            },
            {
                path: 'dashboard/table/bootstrap-table',
                element: <ProtectedRoute allowedRoles={['admin', 'super-admin']}><BootstrapTable /></ProtectedRoute>
            },
            {
                path: 'dashboard/table/table-data',
                element: <ProtectedRoute allowedRoles={['admin', 'super-admin']}><TableData /></ProtectedRoute>
            },
            // Icon
            {
                path: 'icons/solid',
                element: <ProtectedRoute allowedRoles={['admin', 'super-admin']}><Solid /></ProtectedRoute>
            },
            {
                path: 'icons/outline',
                element: <ProtectedRoute allowedRoles={['admin', 'super-admin']}><Outline /></ProtectedRoute>
            },
            {
                path: 'icons/dual-tone',
                element: <ProtectedRoute allowedRoles={['admin', 'super-admin']}><DualTone /></ProtectedRoute>
            },
            {
                path: 'dashboard/icon/solid',
                element: <ProtectedRoute allowedRoles={['admin', 'super-admin']}><Solid /></ProtectedRoute>
            },
            {
                path: 'dashboard/icon/outline',
                element: <ProtectedRoute allowedRoles={['admin', 'super-admin']}><Outline /></ProtectedRoute>
            },
            {
                path: 'dashboard/icon/dual-tone',
                element: <ProtectedRoute allowedRoles={['admin', 'super-admin']}><DualTone /></ProtectedRoute>
            }
        ]
    }
]
// const DefaultRouter = () => {
//     return (
//         <TransitionGroup>
//             <CSSTransition classNames="fadein" timeout={300}>
//                 <Switch>
//                     <Route path="/dashboard" exact component={Index} />
//                     {/* user */}
//                     <Route path="/dashboard/app/user-profile"     exact component={UserProfile} />
//                     <Route path="/dashboard/app/user-add"         exact component={UserAdd}/>
//                     <Route path="/dashboard/app/user-list"        exact component={UserList}/>
//                     <Route path="/dashboard/app/user-privacy-setting" exact component={userProfileEdit}/>
//                      {/* widget */}
//                      <Route path="/dashboard/widget/widgetbasic"   exact component={Widgetbasic}/>
//                      <Route path="/dashboard/widget/widgetcard"    exact component={Widgetcard}/>
//                      <Route path="/dashboard/widget/widgetchart"   exact component={Widgetchart}/>
//                      {/* icon */}
//                      <Route path="/dashboard/icon/solid"           exact component={Solid}/>
//                      <Route path="/dashboard/icon/outline"         exact component={Outline}/>
//                      <Route path="/dashboard/icon/dual-tone"       exact component={DualTone}/>
//                      {/* From */}
//                      <Route path="/dashboard/form/form-element"    exact component={FormElement}/>
//                      <Route path="/dashboard/form/form-validation" exact component={FormValidation}/>
//                      <Route path="/dashboard/form/form-wizard"     exact component={FormWizard}/>
//                      {/* table */}
//                      <Route path="/dashboard/table/bootstrap-table" exact component={BootstrapTable}/>
//                      <Route path="/dashboard/table/table-data"      exact component={TableData}/>
//                      {/*special pages */}
//                      <Route path="/dashboard/special-pages/billing" exact component={Billing}/>
//                      <Route path="/dashboard/special-pages/kanban" exact component={Kanban}/>
//                      <Route path="/dashboard/special-pages/pricing" exact component={Pricing}/>
//                      <Route path="/dashboard/special-pages/timeline" exact component={Timeline}/>
//                      <Route path="/dashboard/special-pages/calender" exact component={Calender}/>
//                      {/* map */}
//                      <Route path="/dashboard/map/vector" exact component={Vector}/>
//                      <Route path="/dashboard/map/google" exact component={Google}/>
//                      {/* extra */}
//                      <Route path="/dashboard/extra/privacy-policy" exact component={PrivacyPolicy}/>
//                      <Route path="/dashboard/extra/terms-of-service" exact component={TermsofService}/>
//                      {/*admin*/}
//                      <Route path="/dashboard/admin/admin" exact component={Admin}/>
//                 </Switch>
//             </CSSTransition>
//         </TransitionGroup>
//     )
// }

// export default DefaultRouter
